import axios from "axios";
import Cookies from "js-cookie";

const server = cookie => {
	return axios.create({
		baseURL: process.env.REACT_APP_API_URL,
		headers: {
			Authorization: `Bearer ${Cookies.get("token")}`,
			Accept: "application/json",
		},
	});
};

export const uploadServer = cookie => {
	return axios.create({
		baseURL: process.env.REACT_APP_API_URL,
		headers: {
			Authorization: `Bearer ${Cookies.get("token")}`,
			Accept: "application/json",
			"Content-Type": "multipart/form-data",
		},
	});
};

export default server;
